export enum Dimension {
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
}

export default null;
